import { ChangeEvent, FC, useState } from "react";

import { GreenP, RedP } from "../../../global.styles";
import Checkbox from "../../UI/checkbox/checkbox.component";
import RadioButton from "../../UI/radio-buttons/radio-button";
import {
  VehcileTypeArray,
  VehicleType,
} from "../../../redux/vehicles/vehicles.types";

type VehicleSearchFormProps = {
  childSeat: boolean;
  petFriendly: boolean;
  vehicleType: VehicleType;
  onVehicleSelect: (vehicleType: VehicleType) => void;
  onCildSeatSelect: (childSeat: boolean) => void;
  onPetFriendlySelect: (petFriendly: boolean) => void;
};

const VehicleSearchForm: FC<VehicleSearchFormProps> = ({
  childSeat,
  petFriendly,
  vehicleType,
  onVehicleSelect,
  onCildSeatSelect,
  onPetFriendlySelect,
}) => {
  const [error, setError] = useState<string | null>(null);

  const vehicleTypeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    if (VehcileTypeArray.includes(event.target.value as VehicleType)) {
      onVehicleSelect(event.target.value as VehicleType);
    } else {
      setError("Invalid vehicle type selected.");
    }
  };

  const childSeatHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    onCildSeatSelect(isChecked);
  };

  const petFriedlinessHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    onPetFriendlySelect(isChecked);
  };

  if (error) return <RedP>{error}</RedP>;

  return (
    <>
      <GreenP>Vehicle Type:</GreenP>
      <RadioButton
        label="4 Seater"
        id="4Seater"
        name="vehicleType"
        value="4Seater"
        checked={vehicleType === "4Seater"}
        onChange={vehicleTypeHandler}
      />
      <RadioButton
        label="4 Seater Estate"
        id="4SeaterEstate"
        name="vehicleType"
        value="4SeaterEstate"
        checked={vehicleType === "4SeaterEstate"}
        onChange={vehicleTypeHandler}
      />
      <RadioButton
        label="6 Seater"
        id="6Seater"
        name="vehicleType"
        value="6Seater"
        checked={vehicleType === "6Seater"}
        onChange={vehicleTypeHandler}
      />
      <RadioButton
        label="Minibus (7 or 8 seats)"
        id="minibus"
        name="vehicleType"
        value="minibus"
        checked={vehicleType === "minibus"}
        onChange={vehicleTypeHandler}
      />
      <RadioButton
        label="Executive"
        id="executive"
        name="vehicleType"
        value="executive"
        checked={vehicleType === "executive"}
        onChange={vehicleTypeHandler}
      />
      <GreenP>Child Seat:</GreenP>
      <Checkbox
        label="Driver has a Child Seat"
        id="childSeat"
        name="childSeat"
        checked={childSeat}
        onChange={childSeatHandler}
      />
      <GreenP>Pet Friendly:</GreenP>
      <Checkbox
        label="Driver accepts pets"
        id="pet"
        name="pet"
        checked={petFriendly}
        onChange={petFriedlinessHandler}
      />
    </>
  );
};

export default VehicleSearchForm;
